





















































import { Component, Prop, Vue } from "vue-property-decorator";
import { SystemService } from "@/api/system-service";
import { infoModule } from "@/store/modules/info";

@Component({
  components: {
  },
})
export default class Info extends Vue {
  items = [
    {
      date: "2020年5月10日",
      title: "２０２０年６月号配信スタート",
      subtitle: "２０２０年６月号の記事を配信致しました。",
    },
    {
      date: "2020年4月10日",
      title: "２０２０年５月号配信スタート",
      subtitle: "２０２０年５月号の記事を配信致しました。",
    },
  ]

  get info(): string {
    return infoModule.info;
  }

  mounted() {
    infoModule.fetch();
    this.$gtag.pageview({page_title: "お知らせ", page_path: `${process.env.VUE_APP_BASE}/#/info`}); // eslint-disable-line
    console.log("page_title: お知らせ");
  }
}
